
















import NW from '../sdk/NW';
import ConnectBox from "@/components/ConnectBox.vue";

export default {
  name: "Home",
  components: {ConnectBox},
  data(){
    return {
     users:[{
       token: "25885d47cf6d481c96efbfb1c7c82744",
       url: "wss://172.31.129.191:5261/im",
       userId: "d50e794a541d40a5b745d3dc2f62c527",
       videoServer: '172.31.103.116',
       videoWS: 'wss://172.31.129.191:5261/video'
     }, {
       token: "8cf1d9998c554bad822106d37df10985",
       url: "wss://172.31.129.191:5261/im",
       userId: "ae9aa1be59a5430da6ca72fa33934d08",
       videoServer: '172.31.103.116',
       videoWS: 'wss://172.31.129.191:5261/video'
     }, {
       token: "8cf1d9998c554bad822106d37df10985",
       url: "wss://172.31.129.191:5261/im",
       userId: "904c7393629346968183adcf31dda571",
       videoServer: '172.31.103.116',
       videoWS: 'wss://172.31.129.191:5261/video'
     }]
    }
  },
  mounted() {
    // WEBIM.initWebIM(
    //   "ws://10.4.149.59:5260",
    //   100003,
    //   "web",
    //   "12bd53082a324b44976533ab3fa1337f",
    //   72,
    //   "王五",
    //   ""
    // );
  }
};
